
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, class_type, anonRecord_type, list_type, option_type, string_type, record_type, bool_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Project_$reflection, User_$reflection, Requests_ProjectFormDto_$reflection } from "../../Shared/User.js";
import { ClientApiResponse$1_$reflection, AccountSettings_$reflection, FormState_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";
import { PropertyConfigurationEnabledResponse_$reflection, CustomProperty_$reflection, PropertyConfiguration_$reflection } from "../../Shared/PropertyConfiguration.js";
import { BusinessUnitOverviewDto_$reflection } from "../../Shared/BusinessUnit.js";

export class VisibleUserModalState extends Record {
    constructor(IsOpen) {
        super();
        this.IsOpen = IsOpen;
    }
}

export function VisibleUserModalState_$reflection() {
    return record_type("Receiver.Project.Types.VisibleUserModalState", [], VisibleUserModalState, () => [["IsOpen", bool_type]]);
}

export class State extends Record {
    constructor(ProjectId, Form, IsCustomPropertiesEnabled, PropertyConfigurations, Users, VisibleUserModalIsOpen, FormState, BusinessUnits, AccountSettings) {
        super();
        this.ProjectId = ProjectId;
        this.Form = Form;
        this.IsCustomPropertiesEnabled = IsCustomPropertiesEnabled;
        this.PropertyConfigurations = PropertyConfigurations;
        this.Users = Users;
        this.VisibleUserModalIsOpen = VisibleUserModalIsOpen;
        this.FormState = FormState;
        this.BusinessUnits = BusinessUnits;
        this.AccountSettings = AccountSettings;
    }
}

export function State_$reflection() {
    return record_type("Receiver.Project.Types.State", [], State, () => [["ProjectId", option_type(string_type)], ["Form", RequestedValue$1_$reflection(Requests_ProjectFormDto_$reflection())], ["IsCustomPropertiesEnabled", RequestedValue$1_$reflection(bool_type)], ["PropertyConfigurations", RequestedValue$1_$reflection(list_type(PropertyConfiguration_$reflection()))], ["Users", RequestedValue$1_$reflection(list_type(User_$reflection()))], ["VisibleUserModalIsOpen", bool_type], ["FormState", FormState_$reflection()], ["BusinessUnits", RequestedValue$1_$reflection(list_type(BusinessUnitOverviewDto_$reflection()))], ["AccountSettings", RequestedValue$1_$reflection(AccountSettings_$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetName", "SetDescription", "SetEmail", "SetCustomProperties", "SetBusinessUnit", "CreateProject", "UpdateProject", "SetIsOpenVisibleUserModal", "SetVisibleUserIds", "RemoveVisibleUserIds", "ProjectFetched", "ProjectSaved", "CustomPropertiesEnabledFetched", "PropertyConfigurationsFetched", "UsersFetched", "AccountSettingsFetched", "BusinessUnitsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Receiver.Project.Types.Msg", [], Msg, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", list_type(CustomProperty_$reflection())]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", BusinessUnitOverviewDto_$reflection()]))]], [], [], [], [["Item", list_type(string_type)]], [["Item", list_type(string_type)]], [["Item", Project_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", PropertyConfigurationEnabledResponse_$reflection()]], [["Item", list_type(PropertyConfiguration_$reflection())]], [["Item", list_type(User_$reflection())]], [["Item", AccountSettings_$reflection()]], [["Item", list_type(BusinessUnitOverviewDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

